import { Component } from '@angular/core';


@Component({
	selector: 'lb-default-grid-header-cell',
	standalone: true,
	imports: [],
	template: '<ng-content></ng-content>',
	styleUrl: './default-grid-header-cell.component.scss'
})
export class DefaultGridHeaderCellComponent {}
